import React from 'react'
import '../../styles/common/manual-card.css'

interface ManualCardProps {
  title: string
  onClick?: () => void
}

const ManualCard = ({ title, onClick }: ManualCardProps) => {
  const handleCardClick = () => {
    onClick?.()
  }

  return (
    <div
      className="manual-card"
      onClick={handleCardClick}
      style={{ cursor: 'pointer' }}
    >
      <div className="manual-card-content">
        <div className="manual-card-image" />
        <h3>{title}</h3>
        <button className="manual-card-button">View Details</button>
      </div>
    </div>
  )
}

export default ManualCard
